import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  padding: 16px;
  padding-bottom: 14px;
  font-size: 0.75rem;
  border: 0.5px solid #c0c0c0;
  border-radius: 8px;

  & + & {
    margin-top: 8px;
  }

  > div {
    flex: 1;
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .invoice-number {
    font-size: 0.875rem;
    color: var(--main-color);
    margin-right: 10px;
    line-height: 16px;
  }
`;

export const BodyCard = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 12px;

  span + span {
    margin-top: 12px;
  }
`;

export const BodyCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const RightArea = styled.div`
  display: flex;
  flex: 2;
  max-width: 150px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
`;

interface IActionAreaProps {
  selected: boolean;
}

export const ActionArea = styled.div<IActionAreaProps>`
  display: flex;
  margin-top: 16px;

  svg {
    font-size: 36px;
  }

  #select-button {
    color: #e0e0e0;
  }

  ${props =>
    props.selected &&
    css`
      #select-button {
        color: #2f7d31;
      }
    `}
`;

export const FileDownloader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 16px;

  span {
    margin-left: 8px;
  }

  @media (max-width: 600px) {
    margin-left: 0px;
    justify-content: space-between;

    button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    span {
      margin-left: 0px;
    }
  }
`;

export const Input = styled.div`
  font-size: 0.75rem;
  font-weight: 600;

  & + & {
    margin-top: 16px;
  }
`;
